import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import ClipLoader from "react-spinners/ClipLoader";
import OutletHead from '../../../../components/common/outlet-head';
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';
import Skeleton from 'react-loading-skeleton';

function GeneralSettings() {

  const { user, settings } = useAuth();
  const { bid } = user.claims;
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [generalData, setGeneralData] = useState({
    paymentTerms: '30',
    taxRate: '0',
    overdueInterest: '0',
    propertyType: '',
    termsConditions: null,
    updatedOn: null
  });
  const [inputError, setInputError] = useState();

  useEffect(() => {
    if (settings) {
      settings.forEach(doc => {
        if (doc.id === 'general') {
          setGeneralData(doc);
        }
      });

      setIsLoading(false);
    }
  }, [settings]);

  async function handleGeneralData(data) {
    const tempData = { ...data, updatedOn: new Date() };
    delete tempData.id;

    try {
      await updateDoc(doc(db, "Businesses", bid, "Settings", 'general'), tempData);
      setIsUpdating(false);
      toast.success('Successfully Updated');
    } catch (error) {
      console.log('Updating Settings [Error] : ', error);
      setIsUpdating(false);
    }
  }

  function validateData() {
    const { paymentTerms } = generalData;
    if (!paymentTerms) {
      setInputError({ ...inputError, paymentTerms: 'This field is required.' });
    } else {
      setIsUpdating(true);
      handleGeneralData(generalData);
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Payment Settings</h5>
            <p className='mb-0 text-muted'>
              <small>Edit your payment settings and information</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              type="submit"
              className='border py-2 btn-width me-3'
              onClick={() => navigate('/admin/dashboard')}
            >
              <span className='px-4'>Cancel</span>
            </Button>
            <Button
              disabled={settings ? generalData === settings.find(x => x.id === 'payment') : false}
              variant="primary"
              type="submit"
              className='py-2 btn-width'
              onClick={validateData}
            >
              {
                isUpdating ?
                  <div className='d-flex align-items-center justify-content-center'>
                    <span className='me-2'>Saving</span>
                    <ClipLoader color='white' size={16} />
                  </div>
                  :
                  <span>Save Changes</span>
              }
            </Button>
          </div>
        }
      />
      <div className='form-wrapper p-3 border-top' >
        <div className='border overflow-hidden rounded'>
          {
            isLoading ?
              <div className='row px-3 mb-3'>
                <div className='col-6 mt-3'>
                  <Skeleton height={42} />
                </div>
                <div className='col-6 mt-3'>
                  <Skeleton height={42} />
                </div>
              </div>
              :
              <div className='row p-3'>
                <div className='col-md-6 col-12'>
                  <div className='row'>
                    <div className='col-12'>
                      <Form.Group className="mb-3">
                        <Form.Label>Property Type *</Form.Label>
                        <InputGroup>
                          <Form.Select
                            value={generalData && generalData.propertyType}
                            onChange={(event) => setGeneralData({ ...generalData, propertyType: event.target.value })}
                          >
                            <option value={'Building'}>Building</option>
                            <option value={'Land'}>Land</option>
                          </Form.Select>
                        </InputGroup>
                      </Form.Group>
                    </div>
                    <div className='col-6'>
                      <Form.Group className="mb-3" controlId="paymentTerms">
                        <Form.Label>Payment Terms *</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            onChange={(event) => setGeneralData({ ...generalData, paymentTerms: event.target.value })}
                            placeholder='0'
                            className={inputError && inputError.paymentTerms ? 'border-danger border-right-0' : 'border-right-0'}
                            value={generalData && generalData.paymentTerms}
                            isInvalid={inputError && inputError.paymentTerms}
                          />
                          <InputGroup.Text className='py-1'>days</InputGroup.Text>
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">{inputError && inputError.paymentTerms}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className='col-6'>
                      <Form.Group className="mb-3">
                        <Form.Label>Tax Rate</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className='py-1'>GST @</InputGroup.Text>
                          <Form.Select
                            className='border-left-0'
                            value={generalData && generalData.taxRate}
                            onChange={(event) => setGeneralData({ ...generalData, taxRate: event.target.value })}
                          >
                            <option value={'0'}>0%</option>
                            <option value={'0.25'}>0.25%</option>
                            <option value={'3'}>3%</option>
                            <option value={'5'}>5%</option>
                            <option value={'12'}>12%</option>
                            <option value={'18'}>18%</option>
                            <option value={'28'}>28%</option>
                            <option value={'40'}>40%</option>
                          </Form.Select>
                        </InputGroup>
                      </Form.Group>
                    </div>
                    <div className='col-6'>
                      <Form.Group className="mb-3" controlId="overdueInterest">
                        <Form.Label>Overdue Interest Rate</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            placeholder="0"
                            className='border-right-0'
                            onChange={(e) => {
                              setGeneralData({
                                ...generalData,
                                overdueInterest: e.target.value,
                              });
                              setInputError({ ...inputError, overdueInterest: '' })
                            }}
                            value={generalData && generalData.overdueInterest}
                          />
                          <InputGroup.Text className='py-1'>%</InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </div>
                    <div className='col-6'>
                      <Form.Group className="mb-3">
                        <Form.Label>Overdue Tax Rate</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className='py-1'>GST @</InputGroup.Text>
                          <Form.Select
                            className='border-left-0'
                            value={generalData && generalData.overdueTaxRate}
                            onChange={(event) => setGeneralData({ ...generalData, overdueTaxRate: event.target.value })}
                          >
                            <option value={'0'}>0%</option>
                            <option value={'0.25'}>0.25%</option>
                            <option value={'3'}>3%</option>
                            <option value={'5'}>5%</option>
                            <option value={'12'}>12%</option>
                            <option value={'18'}>18%</option>
                            <option value={'28'}>28%</option>
                            <option value={'40'}>40%</option>
                          </Form.Select>
                        </InputGroup>
                      </Form.Group>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 col-12'>
                  <div className='row'>
                    <div className='col-12'>
                      <Form.Group>
                        <Form.Label>Terms and Conditions</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={10}
                          placeholder='Enter terms and conditions'
                          onChange={(event) => setGeneralData({ ...generalData, termsConditions: event.target.value })}
                          value={generalData && generalData.termsConditions}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
          }
        </div>
      </div>
    </section>
  );
}

export default GeneralSettings;